// routes/_authenticated/documents/$type/$cnpj/$year/$referenceDate/index.tsx
// — graceful handler for truncated document URLs. The route tree only
// accepts `/documents/$type/$cnpj/$year/$referenceDate/$idDoc[/$versao]`,
// so any link that stops at `$referenceDate` (e.g. shared by hand or from a
// tool that copied the URL before idDoc was wired) lands here instead of
// hitting the generic 404 in `__root.tsx`.
//
// ponytail: render the same `MissingSegmentCard` copy as the deeper
// `$idDoc` and `$idDoc/$versao` siblings — keeping the explanation in one
// place matters less than keeping the *message* identical so users learn
// the missing field from one hint, not three. The card itself is inlined
// here instead of imported to keep the three shallow route files
// self-contained; each is two screens of code and the duplication is the
// honest price.
import { createFileRoute, Link } from "@tanstack/react-router";

import { PageShell } from "@/components/page-shell";
import { Button } from "@/components/ui/button";
import { BackButton } from "@/routes/_authenticated/documents/$type/-back-button";

export const Route = createFileRoute("/_authenticated/documents/$type/$cnpj/$year/$referenceDate/")(
  {
    component: TruncatedDocumentRoute,
  },
);

function TruncatedDocumentRoute() {
  return (
    <PageShell
      title="Documento"
      description="A URL parou antes do identificador do documento."
      actions={<BackButton />}
    >
      <MissingIdDocCard />
    </PageShell>
  );
}

function MissingIdDocCard() {
  return (
    <div
      className="flex flex-col items-center gap-3 rounded-md border border-dashed py-12 text-center"
      data-testid="document-missing-segment"
    >
      <div className="text-sm font-medium">URL de documento incompleta</div>
      <div className="text-muted-foreground max-w-md text-xs">
        Esta rota exige <code>type</code>, <code>cnpj</code>, <code>year</code>,{" "}
        <code>referenceDate</code> e <code>idDoc</code> como segmentos do caminho. Volte ao
        dashboard e clique em um filing recente.
      </div>
      <Button asChild variant="outline" size="sm">
        <Link to="/dashboard">Voltar ao dashboard</Link>
      </Button>
    </div>
  );
}
